<template>
  <van-tabs v-model:active="active">
    <van-tab title="未缴费">
      <div class="list">
        <!-- <div class="total">共{{ totalNum }}个任务:</div> -->

        <van-list
          finished-text="没有更多了"
          :immediate-check="false"
          :offset="50"
        >
          <ul ref="scroll_ul">
            <li v-for="(item, index) in list" :key="index">
              <div class="actionsheet-box-bd1">
                <div class="actionsheet-box-item1">
                  <div class="actionsheet-box-item-label-wrap1">
                    <div
                      class="actionsheet-box-item-label1"
                      style="padding-left: 5px"
                    >
                      就诊科室: {{ item.deptName }}
                    </div>
                    <div
                      class="actionsheet-box-item-label1"
                      style="padding-left: 5px"
                    >
                      就诊时间: {{ item.seeDate }}
                    </div>
                    <div class="actionsheet-box-item-label1 line">
                      <div
                        class="money"
                        style="
                          float: left;
                          width: 73%;
                          box-sizing: border-box;
                          padding-left: 3px;
                        "
                      >
                        ￥{{ item.totCost }}
                      </div>
                      <div
                        class="actionsheet-box-item-value1 money"
                        style="
                          float: left;
                          width: 27%;
                          text-align: right;
                          box-sizing: border-box;
                          padding-right: 3px;
                          margin-top: 3px;
                        "
                      >
                        <!-- <router-link
                            @click.native="goAuth(item)"
                            style="text-decoration: none; color: #3b71e8"
                            >去支付</router-link
                          > -->

                        <van-button
                          style="height: 25px; font-size: 12px"
                          round
                          block
                          color="#0D7CFF"
                          replace
                          @click.native="goAuth({ item })"
                        >
                          去支付
                        </van-button>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </li>
          </ul>
        </van-list>
      </div>
    </van-tab>
    <van-tab title="已缴费">
      <div class="list">
        <!-- <div class="total">共{{ totalNum }}个任务:</div> -->

        <van-list
          v-model="loading"
          :finished="finished"
          @load="onLoad"
          :immediate-check="false"
          :offset="50"
        >
          <ul ref="scroll_ul">
            <li v-for="(item, index) in listPayed" :key="index">
              <div class="actionsheet-box-bd1" @click="showResult(item)">
                <div class="actionsheet-box-item1">
                  <div class="actionsheet-box-item-label-wrap1">
                    <div
                      class="actionsheet-box-item-label1"
                      style="padding-left: 5px"
                    >
                      就诊科室: {{ item.deptName }}
                    </div>
                    <div
                      class="actionsheet-box-item-label1"
                      style="padding-left: 5px"
                    >
                      就诊时间: {{ item.seeDate }}
                    </div>
                    <div class="actionsheet-box-item-label1 line">
                      <div
                        class="money"
                        style="
                          float: left;
                          width: 80%;
                          box-sizing: border-box;
                          padding-left: 3px;
                        "
                      >
                        ￥{{ item.totCost }}
                      </div>
                      <div
                        v-if="item.paymentStatus == '2'"
                        class="actionsheet-box-item-value1 money"
                        style="
                          float: left;
                          width: 20%;
                          text-align: right;
                          box-sizing: border-box;
                          padding-right: 3px;
                          color: grey;
                          font-weight: normal;
                        "
                      >
                        已退费
                      </div>
                      <div
                        v-if="item.paymentStatus == '1'"
                        class="actionsheet-box-item-value1 money"
                        style="
                          float: left;
                          width: 20%;
                          text-align: right;
                          box-sizing: border-box;
                          padding-right: 3px;
                          color: grey;
                          font-weight: normal;
                        "
                      >
                        已完成
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </li>
          </ul>
        </van-list>
      </div>
    </van-tab>
  </van-tabs>
</template>
  <script>
import requests from "../../api/requests.js";
import { ref } from "vue";
import { Form, Field, CellGroup, Button, Dialog,Toast } from "vant";

export default {
  components: {
    Form,
    Field,
    CellGroup,
    Button,
  },
  setup() {
    const active = ref(0);
    return { active };
  },

  data() {
    return {
      openid: "",
      list: [], //待支付
      listPayed: [], //待支付
      serachValue: "", //当前搜索框值
      loading: false,
      finished: false,
      totalNum: 0, //加载出当前所有条数
      isSearch: false,
      refreshing: false, //下拉刷新
      prams: {
        //搜索事件和加载后台数据，参数都是由后端代码定义的
        current: 1, //当前页
        size: 10, //每页显示总数
        fields: [
          {
            fieldName: "woCode",
            fieldOpt: "like",
            fieldVal: "",
          },
          {
            fieldName: "createTime",
            fieldOpt: "order by",
            fieldVal: "desc",
          },
        ],
      },
    };
  },
  created() {
    Toast.loading({
      duration: 0,
      forbidClick: true,
      overlay: true,
      message: "加载中...",
    });
    let that = this;
    let code = this.$route.query.code;
    let httpURL = "/wx/wxauth?code=" + code;

    let globalOpenid = localStorage.getItem(this.GLOBAL.hosUrl);
    that.openid = globalOpenid;

    // Dialog.alert({
    //   title: "消息提示1",
    //   message: localStorage.getItem("openid"),
    // });
    // Dialog.alert({
    //   title: "消息提示2",
    //   message: that.openid,
    // });
    if (that.openid == "" || that.openid == null) {
      requests.get(httpURL).then(function (res) {
        if (res.data != null && res.data.openid != null) {
          that.openid = res.data.openid;
          localStorage.setItem(that.GLOBAL.hosUrl, res.data.openid);

          that.getAllNeedpay(res.data.openid);
          that.getAllPayed(res.data.openid);
        } else {
          console.log(res);
        }
      });
    } else {
      that.getAllNeedpay(that.openid);
      that.getAllPayed(that.openid);
    }
  },

  methods: {
    showResult(item) {
      if (item.paymentStatus == "2") return;
      else this.$router.push({ path: "/payResult", query: { order: item } });
    },

    goAuth(item) {
      localStorage.setItem("order", JSON.stringify(item));
      this.$router.push("/payFee");
    },

    getAllNeedpay(openid) {
      const that = this;
      let httpURL = "/His/QueryRegister?openid=" + openid + "&paymentStatus=0";
      requests.get(httpURL).then(function (res) {
        console.log(res);
        if (res.data != null) {
          that.list = res.data;
          console.log(that.list);
          that.finished = true;
          that.loading = false;
        } else {
          Dialog.alert({
            title: "消息提示",
            message: res.message,
          });
        }
      }).finally((res)=>{
        Toast.clear();
      });
    },
    getAllPayed(openid) {
      const that = this;
      let httpURL = "/His/QueryRegister?openid=" + openid + "&paymentStatus=1";
      // requests.get(httpURL).then(res=>{
      //   this.userInfo = res.data;
      // });
      requests.get(httpURL).then(function (res) {
        console.log(res);
        if (res.data != null) {
          that.listPayed = res.data;
          console.log(that.listPayed);
          that.finished = true;
          that.loading = false;
        } else {
          Dialog.alert({
            title: "消息提示",
            message: res.message,
          });
        }
      });
    },
    onLoad() {
      // that.finished = true;
      // that.loading = false;
      // if (this.refreshing) {
      //   this.list = [];
      //   this.refreshing = false;
      //   this.prams.fields[0].fieldVal = this.serachValue;
      // } else if (this.isSearch) {
      //   this.list = [];
      //   this.totalNum = 0;
      //   this.prams.current = 1;
      //   this.prams.fields[0].fieldVal = this.serachValue;
      // } else {
      //   this.prams.current++;
      // }
      // this.getAllNeedpay();
    },
    onSearch(val) {
      this.totalNum = 0;
      this.prams.current = 1;
      if (val === "") {
        this.isSearch = false;
      } else {
        this.isSearch = true;
      }
      this.onLoad();
      // this.getAllNeedpay();
    },
    onRefresh() {
      // 清空列表数据
      this.finished = false;
      this.refreshing = true;
      // 重新加载数据
      // 将 loading 设置为 true，表示处于加载状态
      this.loading = true;
      this.totalNum = 0;
      this.prams.current = 1;
      this.onLoad();
    },
    clear() {
      this.serachValue = "";
    },
  },
};
</script>
<style lang="less" scoped>
ul {
  box-sizing: border-box;
  padding: 0 0px;
  li {
    list-style: none;
    height: 110px;
    text-align: center;
    line-height: 110px;
    // border: 1px 1px 1px 1px solid rgb(176, 27, 27);
  }
  li.noData {
    height: 28px;
    width: 100%;
    line-height: 28px;
    text-align: center;
    font-size: 16px;
    color: rgba(0, 0, 0, 0.6);
    border: none;
  }
}
.warpper {
  position: relative;
  padding: 0px 0;
}
.topText {
  position: absolute;
  left: 0;
  top: 0;
  height: 18px;
  width: 100%;
  line-height: 18px;
  text-align: center;
  font-size: 13px;
  color: rgba(0, 0, 0, 0.5);
}
.bottomTest {
  position: absolute;
  left: 0;
  bottom: 0;
  height: 18px;
  width: 100%;
  line-height: 18px;
  text-align: center;
  font-size: 13px;
  color: rgba(0, 0, 0, 0.5);
}
.actionsheet-box-item-label-wrap1 {
  width: 100%;
  background-color: #ffffff;
}

.actionsheet-box-bd1 {
  padding: 10px;
  border-top: 1px solid #f8f8f8;
  background-color: #f8f8f8;
}

.actionsheet-box-hd1 {
  position: relative;
  font-size: 16px;
  line-height: 22px;
  font-weight: bold;
  color: #303133;
  margin: 25px 0 17px;
  padding: 0 20px;
}

.actionsheet-box-hd1:before {
  content: "";
  position: absolute;
  left: 4px;
  top: 50%;
  width: 4px;
  height: 17px;
  transform: translateY(-50%);
  background-color: #3b71eb;
}
.actionsheet-box-item1 {
  display: flex;
  justify-content: space-between;
  font-size: 14px;
  line-height: 100px;
}

.actionsheet-box-item1 + .actionsheet-box-item1 {
  margin-top: 12px;
}

.actionsheet-box-item-label1 {
  color: #0a0a0a;
  font-size: 14px;
  text-align: left;
  height: 32px;
  line-height: 32px;
}
.line {
  border-top-color: #f3f0f4;
  border-top-width: 1px;
  border-top-style: solid;
}

.actionsheet-box-item-sublabel1 {
  color: #909399;
}

.actionsheet-box-item-value1 {
  color: #606266;
}

.actionsheet-box-item-value1.em {
  color: #3b71eb;
}

.money {
  font-weight: bold;
  color: coral;
}
.van-button__text {
  font-weight: normal;
}
</style>
  


// WEBPACK FOOTER //
// src/views/orders/index.vue